import { render, staticRenderFns } from "./ifcViewer.vue?vue&type=template&id=0258a538&"
import script from "./ifcViewer.vue?vue&type=script&lang=js&"
export * from "./ifcViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports